import type DataResponse from '@/types/DataResponse'
import { http } from '../plugins/http'
import type TicketBatch from '@/types/TicketBatch'
import type { TicketBatchPayload } from '@/types/TicketBatch'

export default class TicketBatchService {
  async index(eventId: string, filters?: { ticketTypeId?: string, posId?: string }) {
    const params = new URLSearchParams()
    if (filters?.ticketTypeId) params.set('ticket_type_id', filters.ticketTypeId)
    if (filters?.posId) params.set('pos_id', filters.posId)
    const qs = params.size ? `?${params}` : ''
    return await http.get<DataResponse<TicketBatch[]>>(`/api/v1/office/events/${eventId}/batches${qs}`)
  }

  async store(eventId: string, ticketTypeId: string, posId: string, payload: TicketBatchPayload) {
    return await http.post<DataResponse<TicketBatch>>(
      `/api/v1/office/events/${eventId}/batches`,
      { ...payload, ticket_type_id: ticketTypeId, pos_id: posId },
    )
  }

  async update(eventId: string, batchId: string, payload: TicketBatchPayload) {
    return await http.put<DataResponse<TicketBatch>>(
      `/api/v1/office/events/${eventId}/batches/${batchId}`,
      payload,
    )
  }

  async destroy(eventId: string, batchId: string) {
    return await http.delete(`/api/v1/office/events/${eventId}/batches/${batchId}`)
  }
}
